import {AppNavbar, hasCognitoTokens} from '@checkit/react-components';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import {connect} from 'react-redux';
import {LogoutFunction} from '../../auth/state';
import config from '../../config';
import {State} from '../../state';
import useStyles from './styles';

interface Props {
  logoutFunction: LogoutFunction | null;
  handleDrawerToggle: () => void;
}

const TopNavbar: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  const homeHandler = () => {
    if (config.controlCentre.url) {
      window.location.href = config.controlCentre.url;
    }
  };

  const helpHandler = () => {
    if (config.help.url) {
      window.open(config.help.url);
    }
  };

  const currentUserHandler = () => {
    if (config.controlCentre.url) {
      window.location.href = config.controlCentre.url + '/profile';
    }
  };

  const infoToolTipTitle = `v${config.version} (${config.gitBranch}:${config.gitCommit})`;

  return (
    <AppNavbar
        home={homeHandler}
        help={helpHandler}
        infoToolTipTitle={infoToolTipTitle}
        currentUser={currentUserHandler}
        logout={hasCognitoTokens() ? undefined : props.logoutFunction || undefined}
        position="fixed"
        className={classes.appBar}
    >
      <IconButton
          color="inherit"
          aria-label="Open drawer"
          edge="start"
          onClick={props.handleDrawerToggle}
          className={classes.menuButton}
      >
        <MenuIcon/>
      </IconButton>
    </AppNavbar>
  );
};

const mapStateToProps = (s: State) => ({
  logoutFunction: s.auth.authenticated ? s.auth.logoutFunction : null
});

export default connect(mapStateToProps)(TopNavbar);
